// excelRateCodes.js
import ExcelJS from 'exceljs'

// Enum: key → Excel label
export const CATEGORY_LABELS = {
  DirectfulCode: 'Directful',
  OTA: 'OTA',
  OTAOpaque: 'Opaque rates',
  GroupNoConvert: 'Group no convert',
  GroupNoReach: 'Group no reach',
  Employee: 'Employee',
  FriendsAndFamily: 'Friends & family',
  LongTermResident: 'Long term resident',
  AirlineDistress: 'Airline distress',
  Unknown: 'Uncategorized',
  CorporateLocal: 'Corporate local',
  CorporateBrand: 'Corporate brand',
  GovernmentLocal: 'Government local',
  GovernmentBrand: 'Government brand',
  Complimentary: 'Complimentary',
  RewardPointsClaim: 'Reward points claim',
  DiscountLocal: 'Discount local',
  DiscountBrand: 'Discount brand',
  DiscountClub: 'Discount club',
  Direct: 'Direct'
}

// Reverse lookup: Excel label → enum key
const LABEL_TO_KEY = Object.fromEntries(
  Object.entries(CATEGORY_LABELS).map(([key, label]) => [label, key])
)

/**
 * Reads uploaded Excel file and returns grouped bucket JSON.
 * Output:
 * {
 *   Unknown: [{code}], OTA: [{code}], ...
 * }
 */
export async function parseExcelToRateCodeBuckets(file) {
  const arrayBuffer = await file.arrayBuffer()
  const workbook = new ExcelJS.Workbook()
  await workbook.xlsx.load(arrayBuffer)

  const sheet = workbook.getWorksheet('Rates') || workbook.worksheets[0] || null

  if (!sheet) throw new Error('Could not find any sheet in Excel')

  // Initialize empty buckets for all categories (so missing ones remain like [])
  const result = {}

  const { Unknown, ...categoryLabelsExceptUnknown } = CATEGORY_LABELS

  for (const key of Object.keys(categoryLabelsExceptUnknown)) {
    result[key] = []
  }

  // Parse rows
  sheet.eachRow((row, rowNo) => {
    if (rowNo === 1) return // skip header

    const codeValue = row.getCell(1).value
    const categoryValue = row.getCell(2).value

    if (categoryValue === CATEGORY_LABELS.Unknown) return // skip Uncategorized rows

    if (!codeValue) return

    const code = String(codeValue).trim()
    const categoryLabel = categoryValue ? String(categoryValue).trim() : ''

    // map label → enum key
    let bucketKey = LABEL_TO_KEY[categoryLabel] || 'Unknown'

    // append the code
    result[bucketKey].push({ code })
  })

  return result
}

export default parseExcelToRateCodeBuckets
